function slider_main(){
var feature_collection_slider = document.querySelector('.featured-collection-section .grid');
  var flkty = new Flickity( feature_collection_slider, {
        cellAlign: 'center',
        groupCells: true,
        wrapAround: true,
        autoPlay: true
  });

  var text_columns_slider = document.querySelector('.template-index .text-columns-section .grid');
  var flkty = new Flickity( text_columns_slider, {
        cellAlign: 'left',
        wrapAround: true
  });

  
    let text_image_slider = document.querySelectorAll('.image-with-text-slider .images-carousel');
    for (var i = 0; i < text_image_slider.length; i++) {
      let slider = new Flickity(text_image_slider[i], {
        cellAlign: 'left',
        wrapAround: true
      });
    }
 
  var logo_bar_slider = document.querySelector('.logo-bar');
  var flkty = new Flickity( logo_bar_slider, {
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true
  });

  var blog_post_slider = document.querySelector('.blog-posts-section .grid');
  var flkty = new Flickity( blog_post_slider, {
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true
  });


  if ($(window).width() <= 992) {
    var collection_list_slider = document.querySelector('.template-index .custom-collection-list-section .grid');
    var flkty = new Flickity( collection_list_slider, {
          cellAlign: 'left',
          groupCells: '2',
          wrapAround: true
    });

    var pro_hotspot_slider = document.querySelector('.template-product .custom-hotspots-section .hotspots-wrapper');
    var flkty = new Flickity( pro_hotspot_slider, {
          cellAlign: 'left',
          wrapAround: true,
          dots: false,
          prevNextButtons: false
    });
    
    var hotspot_slider = document.querySelector('.template-index .custom-hotspots-section .hotspots-wrapper');
    var flkty = new Flickity( hotspot_slider, {
          cellAlign: 'center',
          wrapAround: true
    });

    var subscription_slider = document.querySelector('.subscription-section .subscription-grid');
    var flkty = new Flickity( subscription_slider, {
          cellAlign: 'center',
      adaptiveHeight: true,
          wrapAround: true
    });
  
  }
  if ($(window).width() < 1080) {
    var announce_slider = document.querySelector('.announcement-slider');
    var flkty = new Flickity( announce_slider, {
        cellAlign: 'left',
        wrapAround: true,
        autoPlay: true
      });
    }
  /*Slider subscription-section */
  //   setTimeout(() => {
  //   var subscription_slider = document.querySelector('.subscription-section .subscription-grid');
  //     var flkty = new Flickity( subscription_slider, {
  //           cellAlign: 'center',
  //           wrapAround: false
  //     });
  // }, "1000");
  /*Slider subscription-section */

  
}




document.addEventListener("DOMContentLoaded", function() {
  var showBtn = document.querySelector('.show_btn_des');
  var fullDescription = document.querySelector('.des_txt_full');
  var shortDescription = document.querySelector('.des_txt_short');

  if (showBtn) {
    showBtn.addEventListener('click', function() {
        fullDescription.style.display = 'block';
        shortDescription.style.display = 'none';
        showBtn.style.display = 'none';
    });
  }
});

var pdp_complementary_slider = document.querySelector('[data-custom-product-meta]');
if(pdp_complementary_slider){
  var pdp_complementary_slider_main = pdp_complementary_slider.querySelector('[data-slideshow]');
  const perSlide = parseFloat(pdp_complementary_slider_main.dataset.perSlide);
const count = parseFloat(pdp_complementary_slider_main.dataset.count);
        if (perSlide < count) {
           const cust_main_pdp_complementary_slider = new Flickity(pdp_complementary_slider_main, {
                prevNextButtons:true,
                pageDots:true,
                adaptiveHeight: true,
                wrapAround: true,
                groupCells: true,
                cellAlign: 'left'
              });
        }
}

function addtocart_custom(){
var status = {
      loading: false
    };
  
     $(".quic-add-btn-main-wapper .product-single__form.quick_add_form").on("submit",function(evt){
         evt.preventDefault();
            // Loading indicator on add to cart button

       if (status.loading) {
          return;
        }
       status.loading = true;
       
         $(this).find('button.add-to-cart').addClass('btn--loading');
         
            var data = theme.utils.serialize(this);
           const $_this = $(this)
            fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: data,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                error(data,$_this);
              } else {
                var product = data;
                success(product,$_this);
              }
            })
    
         function success(product,form){
           // console.log(form);
           $('.product-single__form.quick_add_form .error')
           status.loading = false;
            form.find('button.add-to-cart').removeClass('btn--loading');
           // $('button.add-to-cart').removeClass('btn--loading');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this.addToCart
              }
            }));
         }
    
          function error(error,form) {
            status.loading = false;
             // $('button.add-to-cart').removeClass('btn--loading');
            form.find('button.add-to-cart').removeClass('btn--loading');
             console.log(error);
          }     
     });
}

  addtocart_custom();
 // QUICK ADD TO CART CODE END

document.querySelectorAll(".item").forEach(element => {
  if(element.classList.contains("active")) {
    element.classList.remove("active")
  }
  element.addEventListener("click", function(e) {
    
    if(document.querySelector(".item.active")) {
      document.querySelector(".item.active").classList.remove("active")
    }
    if(element.classList.contains("active")) {
      element.classList.remove("active")
    } else {
      element.classList.add("active")
    }

  })
});
// ------------------------------------Dev added for cstm video section ------------------------------------------
var play_btns = document.querySelectorAll('.play-pause-btn');
if(play_btns){
    play_btns.forEach(function(play_btn) {
        play_btn.onclick = function (e) {
            var video = e.target.parentElement.querySelector('.video-main');
            if (video) {
                document.querySelectorAll('.video-main').forEach(function(vid) {
                    if (vid !== video) {
                        vid.pause();
                        var btn = vid.parentElement.parentElement.querySelector('svg');
                        console.log("btn", btn)
                        if (btn) {
                            btn.style.display = "block";
                        }
                    }
                });              
                if (video.paused) {
                    video.play();    
                    e.target.querySelector('svg').style.display = "none";
                } else {
                    video.pause();
                    e.target.querySelector('svg').style.display = "block";
                }
            }
        };
    });
}
  slider_main();
// testimonial readmore


(function() {

  var collages_img_slider = document.querySelector('.collage_img');
  var flkty = new Flickity( collages_img_slider, {
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true,
        autoPlay: true
  });


  var blog_insta_slider = document.querySelector('.instafeed_content');
  var flkty = new Flickity( blog_insta_slider, {
        cellAlign: 'left',
        wrapAround: true,
        adaptiveHeight: true,
        autoPlay: 1500,
        lazyLoad: true,
        prevNextButtons:false,
        pageDots: false,
  });

var blog_linked_slider = document.querySelector('.linkedin_content');
  var flkty_linkedin = new Flickity( blog_linked_slider, {
        cellAlign: 'left',
        wrapAround: true,
        adaptiveHeight: true,
        autoPlay: 1500,
        lazyLoad: true,
        prevNextButtons:false,
        pageDots: false,
  });



  const openAccordion = (accordion,button) => {
    accordion.classList.add("show-more-height");
    accordion.style.maxHeight = 'max-content';
    console.log(testmonayal_cost);
    if(testmonayal_cost){

      setTimeout(function(){
        testmonayal_cost.resize();
      },500);
      
    }
    if(button) button.textContent = button.getAttribute('data-red-less-text');
  };
  
  const closeAccordion = (accordion,flag) => {
    if(accordion){
      const button = accordion.closest('.testimonials-slide').querySelector('[data-redmore-btn]')
      accordion.classList.remove("show-more-height");
      accordion.style.maxHeight = null;
      if(button) button.textContent = button.getAttribute('data-red-more-text');
      if(flag && testmonayal_cost ){
        setTimeout(function(){
          testmonayal_cost.resize();
        },500);
      }
    }
  };


  const CheckHight = (accordion) => {
    const button = accordion.closest('.testimonials-slide').querySelector('[data-redmore-btn]')
     if(button && accordion.scrollHeight <= 75){
       button.classList.add('hide');
     }
  };


document.addEventListener('DOMContentLoaded', function () {
  const readMoreButtons = document.querySelectorAll('[data-redmore-btn]');
   const all_comtent = document.querySelectorAll("[data-main-content]");
   all_comtent.forEach((man_cont) => CheckHight(man_cont));
  readMoreButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      const content = this.closest('.testimonials-slide').querySelector('[data-main-content]');
         if (content.style.maxHeight) {
            closeAccordion(content,true);
          } else {
            all_comtent.forEach((accordion) => closeAccordion(accordion));
            openAccordion(content,this);
          }
      
      
      // if (content.classList.contains('show-more-height')) {
      //   content.classList.remove('show-more-height');
      //   content.classList.add('expanded');
      //   this.innerText = this.getAttribute('data-red-less-text'); 
      // } else {
      //   content.classList.remove('expanded');
      //   content.classList.add('show-more-height');
      //   this.innerText = this.getAttribute('data-red-more-text'); 
      // }
    });
  });
});

})();


/****** theme custom pagenation Start ******/

function pagination_click_fun(){
  let loadMoreBtn = null;
   loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        // pagination_click_fun(); // reinit click event
      }
        theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}
/****** theme custom pagenation End ******/
 if(document.querySelector(".product__photos .flickity-page-dots")){
    var dots_width = document.querySelector(".product__photos .flickity-page-dots").offsetWidth + 60;
    document.querySelector(".product-section .product__main-photos .flickity-prev-next-button.flickity-previous").style.left = "calc(100% - " + dots_width +  "px)";
}


if ($(window).width() <= 768) {
if(document.querySelector(".product__photos .flickity-page-dots")){
    var dots_width = document.querySelector(".product__photos .flickity-page-dots").offsetWidth + 10;
    document.querySelector(".product-section .product__main-photos .flickity-prev-next-button.flickity-previous").style.left = "calc(50% - " + dots_width +  "px)";
    document.querySelector(".product-section .product__main-photos .flickity-prev-next-button.flickity-next").style.right = "calc(50% - " + dots_width +  "px)";
}
}



// Show password
const togglePassword = document.querySelector('.togglePassword');
const password = document.querySelector('.CustomerPassword');
if(togglePassword && password)
{
  togglePassword.addEventListener('click', function (e) {
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    this.classList.toggle('show-password');
  });
}

// Show password
const togglePassword2 = document.querySelector('#confirm-password');
const password2 = document.querySelector('#ForgotPassword');
if(togglePassword2 && password2) {
  togglePassword2.addEventListener('click', function (e) {
    const type = password2.getAttribute('type') === 'password' ? 'text' : 'password';
    password2.setAttribute('type', type);
    this.classList.toggle('show-password');
  });
}

 $(".disclosure__toggle").click(function(){
    $(".disclosure-list").toggleClass("disclosure-list--visible");
  });

$(".disclosure-list").find(".disclosure-list__item").each(function(){
    $(this).click(function(e){
      e.preventDefault();
      var currntPath = $(this).find('a').attr("data-value");
      if (currntPath == "en"){
       window.location.href = 'https://vivatucasa.ch/en'+location.pathname;
      }
      else{
        var url = location.pathname.replace("/en","");
        window.location.href = 'https://vivatucasa.ch'+url;
      }
    });
  });
// function mobile_lang_open() {
//         var maindrawer = document.querySelector('.toolbar-wrapper') || null;
//         var this_localeDisclosure_disktop =  null;
//         var this_currencyDisclosure_disktop =  null;
//               if(maindrawer){
//                   var localeEl = maindrawer.querySelector('[data-disclosure-locale]');
//                   var currencyEl = maindrawer.querySelector('[data-disclosure-currency]');
//                   if (localeEl) {
//                     this_localeDisclosure_disktop = new theme.Disclosure(localeEl);
//                   }
//                   if (currencyEl) {
//                     this_currencyDisclosure_disktop = new theme.Disclosure(currencyEl);
//                   }
//               }

//   var maenudrawer = document.getElementById('NavDrawer') || null;
//           var this_localeDisclosure_mobile =  null;
//          var this_currencyDisclosure_mobile =  null;
//           if(maenudrawer){
//             var localeEl = maenudrawer.querySelector('[data-disclosure-locale]');
//            var currencyEl = maenudrawer.querySelector('[data-disclosure-currency]');
//              console.log(localeEl)
//             if (localeEl) {
//                 this_localeDisclosure_mobile = new theme.Disclosure(localeEl);
//               }
  
//             if (currencyEl) {
//               this_currencyDisclosure_mobile = new theme.Disclosure(currencyEl);
//             }
//           }
// }

// (function() {
//   mobile_lang_open();
// })();
document.querySelectorAll('img[src*=".gif"]').forEach(img => {
    img.classList.add('gif-image');
});

